import { styled } from "@/stitches/config"

import { SFormFieldElement } from "../FormField/FormField.styles"

export const SFormInput = styled("input", SFormFieldElement, {})
